var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';
import { setAuthToken } from '../services/api';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const savedUser = localStorage.getItem("userData");
            return savedUser ? JSON.parse(savedUser) : null;
        }
        catch (error) {
            console.error("Error parsing saved user:", error);
            return null;
        }
    });
    const [learnerToken, setLearnerToken] = useState(() => {
        return localStorage.getItem("learnerToken");
    });
    // Loading starts false because we restore synchronously from localStorage
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        // Sync axios token when learnerToken changes (or on mount)
        setAuthToken(learnerToken);
    }, [learnerToken]);
    const finishAmeiLogin = (ameToken) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { user: userData, token } = yield authService.authenticate(ameToken);
            setUser(userData);
            if (token) {
                setLearnerToken(token);
                localStorage.setItem("learnerToken", token);
            }
            localStorage.setItem("userData", JSON.stringify(userData));
        }
        catch (error) {
            console.error("Error finishing AMEI login:", error);
            throw error;
        }
    });
    const logout = () => {
        // Tenta recuperar o ID Token do cookie antes de limpar tudo
        const getCookie = (name) => {
            var _a;
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2)
                return (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
            return null;
        };
        const idToken = getCookie("amei_idtoken");
        setUser(null);
        setLearnerToken(null);
        setAuthToken(null);
        localStorage.clear();
        sessionStorage.clear();
        // Limpar cookies
        document.cookie.split(";").forEach((c) => {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        const tokenHint = idToken || "";
        const logoutUrl = `https://amei.homolog.kubernetes.sebrae.com.br/auth/realms/externo/protocol/openid-connect/logout?client_id=ead&post_logout_redirect_uri=${encodeURIComponent('https://beta.sebrae.com.br/portalsebrae/contato')}&id_token_hint=${tokenHint}`;
        window.location.href = logoutUrl;
    };
    return (_jsx(AuthContext.Provider, { value: {
            user,
            learnerToken,
            loading,
            isAuthenticated: user != null,
            finishAmeiLogin,
            logout
        }, children: children }));
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
//# sourceMappingURL=AuthContext.js.map